export const standardsCss = {
  marginRight: "0.5rem",
};

export const standardsButtonCss = {
  marginLeft: "-0.5rem",
};
